var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDropHalfBottom = function SvgIconDropHalfBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.574.68 12 1.5l-.573-.82a1 1 0 0 1 1.146 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.5 13.5a8.5 8.5 0 0 1-.86 3.726q-.039.102-.096.19a8.499 8.499 0 0 1-15.088 0 1 1 0 0 1-.096-.19A8.5 8.5 0 0 1 3.5 13.5c0-3.735 2.063-6.965 3.995-9.187A25.4 25.4 0 0 1 11.07.944a15 15 0 0 1 .327-.242l.02-.015.006-.004.002-.001.002-.001L12 1.5l.573-.82.002.002.002.001.006.004.02.015.07.05.257.192a25.389 25.389 0 0 1 3.575 3.368C18.437 6.536 20.5 9.766 20.5 13.5m-2.03.625a6.5 6.5 0 0 1-.42 1.75H5.95a6.5 6.5 0 0 1-.42-1.75zm-.084-2c-.41-2.478-1.853-4.732-3.39-6.5A23.4 23.4 0 0 0 12 2.755q-.228.183-.524.433a23.4 23.4 0 0 0-2.471 2.437c-1.538 1.768-2.982 4.022-3.39 6.5zM7.404 18.096a7 7 0 0 1-.211-.221h9.614a6.5 6.5 0 0 1-9.403.221",
    clipRule: "evenodd"
  }))));
};
export default SvgIconDropHalfBottom;